
import Vue from 'vue'
import importManOrgGisGkh from '@/connectors/managing-organization/import-man-org-gis-gkh'
import ImportLoading from '@/components/import/ImportLoading.vue'
import SelectImportFile from '@/components/import/SelectImportFile.vue'

export default Vue.extend({
  name: 'ImportMOWizard',
  components: { SelectImportFile, ImportLoading },
  data () {
    return {
      tabImport: 1,
      file: null as null | Blob
    }
  },
  methods: {
    importMOGisGkh (file) {
      if (file) {
        const formdata = new FormData()
        formdata.append('file', file)
        this.tabImport = 3
        importManOrgGisGkh(formdata)
          .then(response => {
            console.log('import MO', response.data)
            importManOrgGisGkh(response.data)
              .then(response => {
                console.log('import MO', response.data)
                this.tabImport = 4
              }).catch(e => {
                console.error(e.response)
                // @ts-ignore
                this.$showErrorToast(e.response.data.message)
                this.tabImport = 1
              })
          }).catch(e => {
            console.error(e.response)
            // @ts-ignore
            this.$showErrorToast(e.response.data.message)
            this.tabImport = 1
          })
      }
    }
  }
})
